<template>
    <div :class="{'lomaltap1-img':customImgLomalta}" style="position: relative;">
        <div v-if="!imageLoaded" class="map-loading-overlay">
            <p>Cargando...</p>
        </div>
        <div :class="widthSvg">

            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :viewBox="img.viewBox" xml:space="preserve">
              <image
                  style="overflow: visible"
                  :width="img.width"
                  :height="img.height"
                  :xlink:href="`${img.url}`"
                  :transform="img.transform"
                  @load="imageLoaded = true"
              >

              </image>
                <polygon
                    class="polygon"
                    v-on:mouseover="inLocation(location, index)"
                    v-on:mouseout="outLocation(location, index)"
                    @click="selectLocation(location)"
                    v-for="(location, index) in filterMapAvaialbles"
                    :key="location.name"
                    :points="location.coords"
                    :shape="location.shape"
                    :style="customPolygon(index)"
                    :stroke="location.color"
                    :name="`${location.name}`"
                />
                <polygon
                    class="polygon"
                    v-show="showDisabledLocations"
                    v-for="(locationD, index) in showDisabledLocations"
                    :key="locationD.name"
                    :points="locationD.coords"
                    :shape="locationD.shape"
                    :style="customPolygonDisabled(index)"
                    :stroke="locationD.color"
                    :name="`${locationD.name}`"
                />
                
                <indicators v-for="indicator in setIndicators" :indicator="indicator" :key="'A' + indicator.text"
                            :filterMapAvaialbles="filterMapAvaialbles"/>
                <text v-show="showDisabledLocations"
                    v-for="(locationD, index) in showDisabledLocations"
                    :key="index"  :transform="locationD.transform" class="st1 st2 st-canadas">
                    {{locationD.text}}
                </text>
                
            </svg>
            <tippy theme="honeybee" size="large" distance="3" ignoreAttributes="true" arrow="true" interactive="true" animation="fade" allowHTML="true" v-for="location in filterMapAvaialbles" :key="location.id" :to="`${location.name}`">
                <Tooltip :desarrollo="desarrollo" :location="location" :type="type" />
            </tippy>
            <div v-if="img.levelId==232 || img.levelId==149 " style="text-align:center">
                <img style="max-width:350px;width:30%" src="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/casas/privadas/simbologia/privada17.png" alt="simbologia">
            </div>
            <div v-if="img.levelId==178 || img.levelId==233 " style="text-align:center">
                <img style="max-width:350px;width:37%" src="https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/casas/privadas/simbologia/casas_chicas.png" alt="simbologia">
            </div>
        </div>
        <map-view-detail v-if="stateMapDetail" />
    </div>
</template>

<script>
import Tooltip from "../Tooltip.vue"
import Indicators from "../Indicators";
import { mapActions, mapGetters } from "vuex";
import MapViewDetail from "../../core/MapViewDetail";

export default {
    name: "MapHighlight",
    props: ["existFilter", "img", "desarrollo", "url", "nivel", "indicators", "type","lomalta",'named',"locationsDisabled"],
    components: {
        Tooltip,
        Indicators,
        MapViewDetail,
    },
    data() {
        return {
            opacity: 0.4,
            stroke: 3,
            target: null,
            name: "",
            offIndicator: false,
            onIndicator: true,
            imageLoaded: false
        };
    },
    computed: {
        ...mapGetters({
            filterModelos: "getStatusFilterModelos",
            stateMapDetail: "getStatusMapDetail"
        }),
        customImgLomalta(){
            if(this.$route.params.id==150 && this.desarrollo=='lomalta-priv'){
                return true
            }else{
                return false
            }
        },
        filterMapAvaialbles() {
            if (this.lomalta) {
                return this.existFilter.filter((location) => location.id != 112)
            }else if (this.nivel === 'towerStage' || this.nivel === 'towerStageLevel') {
                if(this.desarrollo=='canadas_terrenos' || this.desarrollo=='canadas_casas' ){
                    return this.existFilter.filter((location) => location.available >= 0)
                }else{
                    return this.existFilter.filter((location) => location.available > 0)
                }
            } else if (this.type === 'casas') {
                return this.filterModelos
            } else {
                return this.existFilter
            }
        },
        setIndicators() {
            return this.indicators
        },
        widthSvg() {
            if (this.desarrollo === 'canadas_deptos-piso' || this.desarrollo === 'torrespaseodelparquepiso' || this.desarrollo === 'torrevistahermosapiso') {
                return 'box__svg-deptos'
            } else if (this.desarrollo === 'paseodelparqueSubMenu') {
                return 'box__svg-pdp'
            } else if (this.desarrollo === 'bosques_casas') {
                return 'box__svg-bosques'
            }
            return 'box__svg'
        },
        showDisabledLocations(){
            if(this.locationsDisabled){
                return this.locationsDisabled
            }else{
                return false
            }
        },
    },
    methods: {
        ...mapActions(["selectedLocation","getSelectedDpts","getAvailableImageLocation"]),
        selectLocation(location) {
            if (this.nivel === 'availability') {
                this.selectAvailability(location)
            } else if (this.nivel === 'towerStage') {
                this.selectTowerStage(location)
            } else if (this.nivel === 'towerStageLevel') {
                this.selectTowerStageLevel(location)
            }
        },
        selectAvailability(location) {
            
            if (location.statusText === "Disponible") {
                this.$emit('activeDetail')
                setTimeout(() => {
                    this.getAvailableImageLocation(location);
                   
                }, 0);
                this.getSelectedDpts(location)
                /* this.$router.push(`${this.url}/${location.name}`) */
            } else {
                if (location.statusText === "Reservado" || location.statusText === "Vendido") {
                    event.preventDefault();
                }
            }
        },
        selectTowerStageLevel(location) {
            if (location.available > 0) {
                this.selectedLocation(location)
                let nameNoSpace = location.name.replace(/ /g, "");
                this.$router.push({ path: `${this.url}/cve_nivel_te=${location.id}/nombre_nivel_te=${nameNoSpace}` })
            } else {
                event.preventDefault();
            }
        },
        selectTowerStage(location) {
            if (location.available > 0) {
                this.selectedLocation(location)
                let nameNoSpace = location.name.replace(/ /g, "");
                if(this.desarrollo=='paseodelparque'){
                    this.$router.push({ path: `/paseodelparque/nombre_torre_etapa=ETAPA5/cve_torre_etapa=14/cve_nivel_te=196/nombre_nivel_te=BIS` })
                }else{
                 this.$router.push({
                    path: `/${this.url}/nombre_torre_etapa=${nameNoSpace}/cve_torre_etapa=${location.id}`,
                    params: { torre: nameNoSpace, id: location.id }
                }) 
                }
            } else {
                event.preventDefault();
            }
        },
        inLocation(location, index) {
            this.name = location.name
            event.target.style.opacity = 0.3;
            event.target.style.fill = "#"+location.color;
            if (this.nivel === 'towerStageLevel' || this.nivel === 'towerStage') {
                if (location.name === this.setIndicators[index].text) {
                    this.setIndicators[index].status = this.offIndicator
                }
            }
        },
        outLocation(location, index) {
            this.name = "";
            event.target.style.opacity = 0.4;
            event.target.style.fill = `#${this.filterMapAvaialbles[index].color}`;
            if (this.nivel === 'towerStageLevel' || this.nivel === 'towerStage') {
                if (location.name === this.setIndicators[index].text) {
                    this.setIndicators[index].status = this.onIndicator
                }
            }
        },
        customPolygon(index) {
            let location = this.filterMapAvaialbles[index];
            return `stroke-width:3; stroke:#${location.color}; opacity: ${this.opacity}; fill: #${location.color}`;
        },
        
        customPolygonDisabled(index) {
            let locations = this.showDisabledLocations[index];
            return `stroke-width:3; stroke:#${location.color}; opacity: ${this.opacity}; fill: #${locations.color}`;
        },
        beforeDestroy() {
            this.indicators = [];
        }
    },
    
    mounted(){
    }
};
</script>
<style scoped>
.map-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 5;
  text-align: center;
  padding: 50px 0;
  background: #fff;
}
</style>



